
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import ShopHero from "../components/shop/ShopHero";
import CategorySidebar from "../components/shop/CategorySidebar";
import ProductGrid from "../components/shop/ProductGrid";
import ShopToolbar from "../components/shop/ShopToolbar";
import Pagination from "../components/shop/Pagination";

import useProducts from "../hooks/useProducts";
import useCategories from "../hooks/useCategories";


const Shop = () => {

  const { products, loading } = useProducts();
  const {
    categories,
    loading: categoriesLoading
  } = useCategories();


  const [searchParams] = useSearchParams();


  const initialCategory =
    searchParams.get("category") || "All Products";


  const [category, setCategory] =
    useState(initialCategory);


  const [search, setSearch] = useState("");

  const [sort, setSort] = useState("Newest");

  const [currentPage, setCurrentPage] = useState(1);


  const productsPerPage = 5;



  if (loading || categoriesLoading) {

    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading products...
      </div>
    );

  }



  let filteredProducts = products.filter((product) => {


    const productCategory =
      product.category?.title;


    const matchCategory =
      category === "All Products" ||
      productCategory === category;



    const matchSearch =
      product.name
        .toLowerCase()
        .includes(search.toLowerCase());



    return matchCategory && matchSearch;

  });



  if (sort === "Price: Low to High") {

    filteredProducts.sort(
      (a, b) =>
        Number(a.price) - Number(b.price)
    );

  }



  if (sort === "Price: High to Low") {

    filteredProducts.sort(
      (a, b) =>
        Number(b.price) - Number(a.price)
    );

  }



  const totalPages = Math.ceil(
    filteredProducts.length / productsPerPage
  );



  return (

    <main className="bg-gray-50 min-h-screen">


      <ShopHero
        search={search}
        setSearch={setSearch}
      />



      <section className="max-w-7xl mx-auto px-6 py-12">


        <div className="grid lg:grid-cols-[280px_1fr] gap-8">


          <CategorySidebar
            categories={categories}
            category={category}
            setCategory={setCategory}
          />



          <div>


            <ShopToolbar
              sort={sort}
              setSort={setSort}
              count={filteredProducts.length}
            />



            <ProductGrid
              products={filteredProducts}
            />



            <Pagination

              currentPage={currentPage}

              totalPages={totalPages}

              setCurrentPage={setCurrentPage}

            />


          </div>


        </div>


      </section>


    </main>

  );

};


export default Shop;